import React from 'react';
import {Col, Container, Row, Tab, Nav} from "react-bootstrap";

function Ourpractice(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="HRM Solutions">
                            <h2>TekRevol’s HRMS Software Solution Development Process</h2>
                        </div>
                        <p className="main_para">Being one of the best HRMS software companies for HR solutions, we find the right intersection between technology and business use cases, match the size and nature of the business and create a value-driven solution that helps businesses achieve their human-resource-related objectives faster.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Plan</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Build</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Transform</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="0">
                                            <p>The planning phase starts with selecting the right technology stack and choosing between centrally hosted programs and cloud-based infrastructure. Project managers and designers translate the requirements into UI and UX for business process audits.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>The UI and UX designs form the foundations of code – backend, frontend, and API side of the HRMS solution. It’s tested holistically for in-house and international software performance standards and is ready for deployment.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>Once put into action, this HRMS solution automates essential business HR functions. More advanced versions with AI and ML deployments self-learn and transform the internal and external HR procedures.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>

                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Ourpractice;